import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    // Hook for Sentry/analytics integration later.
    console.error('ErrorBoundary caught:', error, info);
  }

  override render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 48, fontFamily: 'Inter, sans-serif', color: 'var(--text)' }}>
          <h1 style={{ fontSize: 24, marginBottom: 12 }}>Something went wrong</h1>
          <p style={{ color: 'var(--text-secondary)', marginBottom: 12 }}>
            {this.state.error.message}
          </p>
          <button onClick={() => location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
